// extracted by mini-css-extract-plugin
export default {"container":"MyStudentsTests_container__W85a+","table":"MyStudentsTests_table__lapek"};